import Swiper from 'swiper/bundle'
import 'swiper/css/bundle'

export const initializeHistorySlider = () => {
  const sliders = document.querySelectorAll('[data-component="history-slider"]')

  sliders.forEach(slider => {
    const swiperElement = slider.querySelector('.swiper')
    const steps = slider.querySelectorAll('[data-component="history-step"]')

    const swiperInstance = new Swiper(swiperElement, {
      slidesPerView: 1,
      speed: 400,
      simulateTouch: true
    })

    const updateActiveStep = () => {
      steps.forEach(step => {
        step.dataset.active = parseInt(step.dataset.stepindex) === swiperInstance.activeIndex ? 'true' : 'false'
      })
    }
    swiperInstance.on('slideChange', updateActiveStep)
    updateActiveStep()

    // Clicking a timeline step jumps straight to that step
    steps.forEach(step => {
      step.addEventListener('click', () => swiperInstance.slideTo(parseInt(step.dataset.stepindex)))
    })

    // --- Cursor and Click Navigation across the whole section ---
    slider.addEventListener('mousemove', (e) => {
      // Reset cursor over the timeline steps themselves, they navigate directly on click
      if (e.target.closest('[data-component="history-step"], a, button')) {
        slider.style.cursor = 'auto'
        slider.dataset.cursorDirection = ''
        return
      }

      const rect = slider.getBoundingClientRect()
      const x = e.clientX - rect.left

      if (x < rect.width / 2) {
        slider.style.cursor = 'var(--cursor-prev)'
        slider.dataset.cursorDirection = 'prev'
      } else {
        slider.style.cursor = 'var(--cursor-next)'
        slider.dataset.cursorDirection = 'next'
      }
    })

    slider.addEventListener('click', (e) => {
      if (e.target.closest('[data-component="history-step"], a, button')) return

      if (slider.dataset.cursorDirection === 'prev') {
        swiperInstance.slidePrev()
      } else {
        swiperInstance.slideNext()
      }
    })

    // Set equal height for all slides
    const setEqualSlideHeights = () => {
      const slides = swiperElement.querySelectorAll('.swiper-slide')
      let maxHeight = 0
      slides.forEach(slide => {
        slide.style.height = 'auto'
        if (slide.offsetHeight > maxHeight) maxHeight = slide.offsetHeight
      })
      if (maxHeight === 0) return
      slides.forEach(slide => { slide.style.height = maxHeight + 'px' })
    }
    setEqualSlideHeights()
    window.addEventListener('resize', setEqualSlideHeights)
    setTimeout(setEqualSlideHeights, 500)
  })
}
